import React, { useEffect, useRef, useState } from 'react';
import {
  Col,
  Row,
  Tabs,
  Tab,
  Button,
  Table,
  Container,
  Card
} from 'react-bootstrap';

import format from 'string-template';
import { useHistory, useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { makeQuery } from 'utils';
import moment from 'moment';
import SipPayMethod from 'shared/sipPayMethod/SipPayMethod';
import { userStore } from 'store/UserStore';
import { netcoreTrack, netcoreDate } from 'utils/netcoreTracking';
import buySellService from 'services/buy-sell.service';
import RedirectToast from 'shared/common/toast/redirectToast';
import { toast } from 'react-toastify';
import useRazorpay, { RazorpayOptions } from 'react-razorpay';
import dashboardService from 'services/dashboard.service';
import OtpPopup from 'shared/common/otp-modal/otpModal';
import {
  ACK_FAIL,
  ACK_SUCCESS,
  OTP_SENT_TO_REG_MESSAGE,
  OTP_VERIFY_FAILURE,
  OTP_VERIFY_SUCCESS,
} from 'constants/messages.constant';
import Loader from 'shared/common/loader';
import SipHttp from "../services/sip.service";
import Layout from 'wrappers/layout';
import "../styles/PaymentSchedule.css";
import ConfirmActionModal from './ConfirmActionModal';

interface PropsType { }


interface ExtendedRazorpayOptions extends RazorpayOptions {
  config?: {
    display: RazorpayOptions['config']['display'] & {
      blocks: Record<string, any>;
      sequence: string[];
      preferences: Record<string, any>;
    };
  };
}

const PaymentSchedule: React.FC<PropsType> = () => {
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const encodedSip = queryParams.get('data');

  const decodedSip = JSON.parse(decodeURIComponent(encodedSip));

  const isMultiMetal = decodedSip?.isMultiMetal;

  const [selectedTab, setSelectedTab] = useState<any>('completedsip');
  const [upcomingList, setUpcomingList] = useState<any>([]);
  const [completedList, setCompeletedList] = useState<any>([]);
  const [isDisplayPayMethod, setIsDisplayPayMethod] = useState<any>(false);
  const [loading, setLoading] = useState<any>(false);
  const abortControllerRef = useRef<AbortController>(new AbortController());

  // const [quoteData, setQuoteData] = useState<any>({
  //   itemCode: decodedSip?.itemCode,
  //   otherItems: [],
  //   requestedType: decodedSip?.installmentAmt ? 'AMOUNT' : 'PRODUCT_QTY',
  //   requestedValue: decodedSip?.installmentAmt
  //     ? decodedSip?.installmentAmt
  //     : decodedSip?.grams,
  //   requestedValueAmount: decodedSip?.installmentAmt
  //     ? decodedSip?.installmentAmt
  //     : null,
  //   requestedValueQuantity: decodedSip?.grams ? decodedSip?.grams : null,
  //   uom: 'g',
  // });

  const [quoteData, setQuoteData] = useState<any>(() => {
    if (isMultiMetal) {
      const [primaryMetal, ...rest] = decodedSip.metals;

      return {
        itemCode: primaryMetal?.itemCode,
        otherItems: rest.map((m: any) => ({
          itemCode: m.itemCode,
          requestedType: 'AMOUNT',
          requestedValue: m.metalInstallmentAmount,
          requestedValueAmount: m.metalInstallmentAmount,
          requestedValueQuantity: null,
          uom: 'g',
        })),
        requestedType: 'AMOUNT',
        requestedValue: primaryMetal?.metalInstallmentAmount,
        requestedValueAmount: primaryMetal?.metalInstallmentAmount,
        requestedValueQuantity: null,
        uom: 'g',
      };
    }

    return {
      itemCode: decodedSip?.itemCode,
      otherItems: [],
      requestedType: decodedSip?.installmentAmt ? 'AMOUNT' : 'PRODUCT_QTY',
      requestedValue: decodedSip?.installmentAmt ?? decodedSip?.grams,
      requestedValueAmount: decodedSip?.installmentAmt ?? null,
      requestedValueQuantity: decodedSip?.grams ?? null,
      uom: 'g',
    };
  });

  const [quoteResp, setQuoteResp] = useState(null);
  const [orderSipId, setOrderSipId] = useState(null);
  const [sipOrderId, setsipOrderId] = useState(null);

  const [showDeactivateModal, setShowDeactivateModal] = useState(false);
  const [isSipActive, setIsSipActive] = useState(
    decodedSip?.status === 'ACTIVE'
  );


  const { id }: any = useParams();
  const onChangeTab = (tab) => {
    setSelectedTab(tab);
  };
  const [customerId, user, selectedAccount, customer] =
    userStore((state: any) => [
      state.customerId,
      state.user,
      state.userData,
      state.selectedAccount,
      state.customer,
      state.setCustomer,
    ]);

  const [paymentMethod, setPaymentMethod] = useState('UPI');
  const [paymentProvider, setPaymentProvider] = useState('RPY');
  const [summary, setSummary] = useState(null);
  const [isOTPModalShow, setIsOTPModalShow] = useState(false);
  const [otpMeta, setOtpMeta] = useState<any>({
    otpId: '',
    otp: '',
    refType: 'B2B-BUYBACK',
    expiredAt: '',
  });
  const [otpData, setOtpData] = useState<OtpData>({
    value: '',
    ackMessage: '',
    ackMessageType: 'success',
  });
  const Razorpay = useRazorpay();
  const [razorpay, setRazorpay] = useState<any>({
    customerId: customerId,
    amount: null,
    paymentMethod: 'NEBK',
  });
  const setInitialStateRazorpay = () => {
    setRazorpay({
      customerId: customerId,
      amount: null,
      transactionTypeId: 'eb-o-00333',
      paymentMethod: 'NEBK',
    });
  };

  const getUpcomingList = async () => {
    try {
      const query = makeQuery({ sip_id: id, user_id: user?.userId });
      const resp = await SipHttp.getUpcomingList(query);
      if (resp?.data?.data[0]) {
        setUpcomingList(resp?.data?.data);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const getCompletedList = async () => {
    try {
      const query = makeQuery({ sip_id: id, user_id: user?.userId });
      const resp = await SipHttp.getCompletedList(query);
      if (resp?.data?.data[0]) {
        setCompeletedList(resp?.data?.data);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const addquoute = async (sipId, orderId) => {
    try {
      const quotedata = {
        currency: 'INR',
        ebActRef: customer?.accountId,
        items: [quoteData],

        type: 'SELL',
      };
      setLoading(true);
      const resp = await buySellService.addQuote(quotedata, user?.userId, '');
      // setPriceBreakdown(resp.data.data);
      setQuoteResp(resp?.data?.data);
      setOrderSipId(sipId);
      setsipOrderId(orderId);

      if (resp.data.data) {
        setLoading(false);
        setIsDisplayPayMethod(true);
      } else {
        setLoading(false);
        toast.error('Something went wrong');
      }
    } catch (err: any) {
      setLoading(false);
      toast.error('Something went wrong');
      console.log(err);
    }

    // console.log('quoteres', resp);
  };

  const displayPayMethod = async (sipId, orderId) => {
    addquoute(sipId, orderId);
    // setIsDisplayPayMethod(true);
  };

  const generateOtp = async (ruleType, otpId = null) => {

    // user.mobile.value

    let payload = user?.mobile?.value;

    try {
      setLoading(true);
      const res: any = await buySellService.generateOtp(
        payload,
        ruleType,
        otpId,
        user.userId
      );
      setLoading(false);
      if (res.status === 200 && res.data.data) {
        setIsOTPModalShow(true);
        setOtpMeta({
          ...otpMeta,
          otpId: res.data.data.otpId,
          expiredAt: res.data.data.expiredAt,
        });
        return toast.success(
          'OTP has been sent to your registered mobile number.'
        );
      }
    } catch (e: any) {
      setLoading(false);
      console.log(e?.data?.errors[0]?.title);
      toast.error('Something went wrong');
      return toast.error(e.data.errors[0].title);
    }
  };

  const placeOrderFunc = async (method) => {
    const payload = {
      ebQuoteRef: quoteResp?.ebQuoteRef,
      paymentMethod: method,
      is_payment_manual: true,
      sip_id: orderSipId,
      order_id: sipOrderId,
      otp: Number(otpData?.value),
      otpId: otpMeta?.otpId,
      ...(method === 'NEBK' && { paymentProvider }),
    };
    try {
      setLoading(true);
      const res: any = await buySellService.placeOrder(
        payload,
        abortControllerRef.current.signal,
        user.userId
      );
      // setLoading(false);
      if (res.status === 200 && res.data.data) {
        setLoading(false);

        if (method !== 'CUSTOMER_WALLET' && method !== 'NEFT') {
          return await setPaymentGatewayConfiguration(res.data.data, method);
        } else {
          setIsOTPModalShow(false);
          resetOtpData();
          getCompletedList();
          toast.success('Order placed successfully');
        }
        // } else if (paymentMethod === 'CUSTOMER_WALLET') {
        //   generateOtp('SELL');
        // }
      }
    } catch (err) {
      console.log(err);
      toast.error('Something went wrong');
      setLoading(false);
    }
  };
  const selectSipPayMethod = async (method) => {
    setPaymentMethod('UPI');
    setIsDisplayPayMethod(false);
    // };

    // const placeOrder = async (payload) => {
    try {
      if (method === 'CUSTOMER_WALLET') {
        if (Number(summary?.walletBalance) < quoteResp.summary.quotationTotal) {
          // setLoading(false);
          return toast.error(
            <RedirectToast
              btnLabel='Go to Wallet'
              label='Wallet balance is not enough'
              showButton
              onBtnClick={() => {
                history.push('/wallet');
              }}
            />,
            { closeOnClick: false }
          );
        } else {
          generateOtp('SELL');
        }
      }

      else {
        await placeOrderFunc(method);
      }
    } catch (err: any) {
      // setLoading(false);
      // setInitialStateItem();

      if (err.data.errors.length > 0) {
        return toast.error(err.data.errors[0].title);
      }
      return toast.error('Something went wrong');
    }
  };

  const checkPaymentStatus = async (paymentId, orderId) => {
    try {
      let payload = {
        paymentId,
        orderId,
      };
      setLoading(true);
      const res = await buySellService.checkPaymentStatus(
        payload,
        abortControllerRef.current.signal
      );
    } catch (error) {
    } finally {
      setLoading(false);
      getCompletedList();
      toast.success('Order placed successfully');
    }
  };
  const onCloseHandler: any = async () => {
    getCompletedList();
  };

  const openEasebuzzCheckout = (accessKey: string, orderRef: string) => {
    if (!accessKey || !orderRef) {
      setLoading(false);
      toast.error('Unable to start payment. Please try again.');
      return;
    }
    const env = process.env.REACT_APP_EASEBUZZ_ENV === 'prod' ? 'prod' : 'test';
    const baseUrl =
      env === 'prod'
        ? 'https://pay.easebuzz.in/pay/'
        : 'https://testpay.easebuzz.in/pay/';
    const checkoutUrl = `${baseUrl}${accessKey}`;

    sessionStorage.setItem('easebuzzOrderRef', orderRef);
    sessionStorage.setItem(
      'easebuzzReturnPath',
      window.location.pathname + window.location.search || '/dashboard'
    );
    window.location.href = checkoutUrl;
  };

  const setPaymentGatewayConfiguration = async (data, method) => {
    const options: ExtendedRazorpayOptions = {
      key: process.env.REACT_APP_RAZORPAY_KEY,
      amount: '',
      currency: 'INR',
      name: 'eBullion',
      description: 'Buy Metals',
      image:
        'https://ebullion-dev.s3.ap-south-1.amazonaws.com/assets/eb-logo.png',
      order_id: '',
      modal: {
        ondismiss: onCloseHandler, // Assigning the onCloseHandler function
      },
      async handler(response: any) {
        setLoading(true);
        const payload = {
          customerId: razorpay.customerId,
          razorpayOrderId: response.razorpay_order_id,
          razorpayPaymentId: response.razorpay_payment_id,
          razorpaySignature: response.razorpay_signature,
          razorpayRequestBody: {
            amount: razorpay.amount,
            currency: 'INR',
            // test: 'testUPIwithRPY',
          },
        };

        setInitialStateRazorpay();
        await checkPaymentStatus(
          response.razorpay_payment_id,
          data?.ebOrderRef
        );
      },
      prefill: {
        name: user.displayName,
        email: user.email.value,
        contact: user.mobile.value,
        method: method === 'UPI' ? 'upi' : 'netbanking',
      },
      config: {
        display: {
          language: 'en',
          blocks: {
            banks: {
              name: paymentMethod === 'UPI' ? 'Pay via UPI' : 'Pay via Net Banking',
              instruments: [
                {
                  method: paymentMethod === 'UPI' ? 'upi' : 'netbanking',
                },
              ],
            },
          },
          sequence: ['block.banks'],
          preferences: {
            show_default_blocks: false,
          },
        },
      },
      notes: {
        address: customer?.billingAddress?.address1,
        is_payment_manual: true,
        sip_id: orderSipId,
        order_id: sipOrderId,
      },
      theme: {
        hide_topbar: false,
        color: '#141034',
        backdrop_color: 'rgba(0, 0, 0, 0.90)',
      },
      timeout: 180,
    };

    if (method === 'UPI') {
      const provider =
        data.meta.payment.response.data.meta.length > 0
          ? data?.meta?.payment?.response.data.meta.filter(
            (data: any) => data.key === 'PAYMENT_PROVIDER'
          )[0]?.value
          : undefined;

      if (provider === 'RPY') {
        options.order_id = data?.meta?.payment?.response.data.meta.filter(
          (data: any) => data.key === 'RPY_ORDER_ID'
        )[0].value;
        razorpay.amount = data.meta.payment.response.data.amount;
        options.amount = (razorpay.amount * 100).toString();
        const razorPay = new Razorpay(options);
        return razorPay.open();
      } else if (provider === 'EBZ') {
        const accessKey = data?.meta?.payment?.response.data.meta.filter(
          (data: any) => data.key === 'EBZ_ACCESS_KEY'
        )[0].value;
        return openEasebuzzCheckout(accessKey, data?.ebOrderRef);
      } else {
        setInitialStateRazorpay();
        setLoading(false);
      }
    }

    if (method === 'NEBK') {
      const provider =
        data.meta.payment.response.data.meta.length > 0
          ? data?.meta?.payment?.response.data.meta.filter(
            (data: any) => data.key === 'PAYMENT_PROVIDER'
          )[0]?.value
          : paymentProvider;

      if (provider === 'EBZ') {
        const accessKey = data?.meta?.payment?.response.data.meta.filter(
          (data: any) => data.key === 'EBZ_ACCESS_KEY'
        )[0].value;
        return openEasebuzzCheckout(accessKey, data?.ebOrderRef);
      }

      if (data.meta.payment.response.data.meta.length > 0) {
        options.order_id = data?.meta?.payment?.response.data.meta.filter(
          (data: any) => data.key === 'RPY_ORDER_ID'
        )[0].value;
      }
      razorpay.amount = data.meta.payment.response.data.amount;
      options.amount = (razorpay.amount * 100).toString();
      const razorPay = new Razorpay(options);
      return razorPay.open();
    }
  };
  const onSubmitOTP = async () => {
    try {
      setLoading(true);
      setOtpMeta({
        ...otpMeta,
        otp: otpData.value,
      });
      let payload = {
        otpId: otpMeta.otpId,
        otp: otpData.value,
      };
      const res: any = await buySellService.verifyOTP(payload, user.userId);
      setLoading(false);
      if (res.status === 200 && res.data.data) {
        setOtpData({
          ...otpData,
          value: '',
          ackMessage: OTP_VERIFY_SUCCESS,
          ackMessageType: ACK_SUCCESS,
        });
        toast.success('OTP verification successful');
        // setLoading(true);
        try {
          const res: any = await placeOrderFunc('CUSTOMER_WALLET');

          if (res?.status == 200) {
            // setLoading(false);
            setIsOTPModalShow(false);
          } else {
            setIsOTPModalShow(false);
          }
        } catch (err) {
          console.log(err);
          setIsOTPModalShow(false);
          toast.error('Something went wrong');
        }

      }
    } catch (e: any) {
      setLoading(false);
      setOtpData({
        value: '',
        ackMessage: OTP_VERIFY_FAILURE,
        ackMessageType: ACK_FAIL,
      });
      return toast.error(e.data.errors[0].title);
    }
  };
  const resetOtpData = () => {
    setOtpData({
      value: '',
      ackMessage: '',
      ackMessageType: 'success',
    });
  };

  const resendOTP = async (otpId: number = 0) => {
    generateOtp('SELL', otpMeta.otpId);
  };

  const getPassbookSummary = async () => {
    try {
      setLoading(true);
      const res: any = await dashboardService.getPassbookSummary(
        customerId,
        user.userId
      );
      if (res.status === 200 && res.data.data) {
        setSummary(res.data.data.summary);
        setLoading(false);
        return Promise.resolve(true);
      } else {
        setLoading(false);
        setIsDisplayPayMethod(false);
        return Promise.reject(false);
      }
    } catch (e: any) {
      console.log(e.message);
      setIsDisplayPayMethod(false);
      setLoading(false);
      return Promise.reject(false);
    }
  };

  const confirmDeactivateSip = async () => {
    try {
      setLoading(true);

      const payload = {
        sip_id: id,
        status: 'INACTIVE',
        user_id: user?.userId,
      };

      const res = await SipHttp.changeSIPStatus(payload);

      if (res?.status === 200) {
        toast.success('SIP deactivated successfully!');
        const sipMetal = isMultiMetal
          ? (decodedSip?.metals || [])
              .map((m: any) => m?.metal ?? m?.metalCode)
              .filter(Boolean)
              .join(',')
          : decodedSip?.metal;
        netcoreTrack(
          'sip_deactivate',
          {
            sip_id: id,
            customer_id: customerId,
            metal: sipMetal,
            frequency: decodedSip?.frequency,
            duration_in_months: Number(decodedSip?.duration) || undefined,
            new_deactivated_at: netcoreDate(new Date()),
          },
          user?.mobile?.value,
          {
            // Other active SIPs are not known here; backend sync owns the true value.
            HAS_ACTIVE_SIP: false,
            SIP_FREQUENCY: decodedSip?.frequency,
            SIP_METAL: sipMetal,
          }
        );
        setIsSipActive(false);
        getUpcomingList();
        getCompletedList();
      } else {
        throw new Error('Failed');
      }
    } catch (err) {
      toast.error('Something went wrong');
    } finally {
      setLoading(false);
      setShowDeactivateModal(false);
    }
  };

  useEffect(() => {
    getUpcomingList();
    getCompletedList();
    getPassbookSummary();
  }, []);
  useEffect(() => {
    const manualSipData = localStorage.getItem('manualSipId');
    if (manualSipData) {
      localStorage.removeItem('manualSipId');
    }
  }, []);

  // ── Resume after an Easebuzz redirect round trip ────────────────────────────────
  // Mirrors the same pattern used in dashboard/components/buy-sell-metals.tsx:
  // params/sessionStorage are only cleaned up once the resume chain actually
  // finishes, so a throwaway remount (if this page briefly re-renders) leaves
  // them intact for the instance that completes.
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const easebuzzStatus = params.get('easebuzzStatus');
    if (!easebuzzStatus) return;

    let isMounted = true;

    const cleanUp = () => {
      sessionStorage.removeItem('easebuzzOrderRef');
      const cleanParams = new URLSearchParams(window.location.search);
      cleanParams.delete('easebuzzOrderRef');
      cleanParams.delete('easebuzzStatus');
      history.replace({ search: cleanParams.toString() });
    };

    if (easebuzzStatus !== 'success') {
      toast.error('Payment failed or cancelled');
      cleanUp();
      return;
    }

    (async () => {
      setLoading(true);
      await getCompletedList();
      if (!isMounted) return;
      setLoading(false);
      toast.success('Order placed successfully');
      cleanUp();
    })();

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout>
      <Container className='py-2'>
        {loading ? (
          <Loader />
        ) : (
          <div className='pb'>
            <Row>
              <Col md={12}>
                <Card className="mb-4 border-0 shadow-sm sip-header-card">
  <Card.Body className="py-2 px-4">
    <div className="sip-header-row">

      {/* LEFT SIDE */}
      <div className="sip-info">
        <span className="sip-label">SIP</span>
        <span className="sip-id">#{id}</span>
        <span className="sip-name">{decodedSip?.planName}</span>
      </div>

      {/* RIGHT SIDE */}
      <div className="sip-actions">
        <span className={`status-pill ${isSipActive ? 'pill-active' : 'pill-inactive'}`}>
          <span className="status-dot" />
          {isSipActive ? 'ACTIVE' : 'INACTIVE'}
        </span>

        {selectedTab === 'upcoming' && (
          <Button
            size="sm"
            className={`sip-deactivate-btn ${isSipActive ? 'btn-danger-soft' : 'btn-deactivated'}`}
            disabled={!isSipActive}
            onClick={() => setShowDeactivateModal(true)}
          >
            {isSipActive ? 'Deactivate' : 'Deactivated'}
          </Button>
        )}
      </div>

    </div>
  </Card.Body>
</Card>
                <Tabs
                  defaultActiveKey={selectedTab}
                  id='uncontrolled-tab-example'
                  className="sip-tabs mb-3"
                  onSelect={onChangeTab}
                >
                  <Tab eventKey='completedsip' title='Orders' className="mb-3">
                    {/* <h2>Payment Schedule :-</h2> */}
                    <Row>
                      <Col md={12}>
                        <div className='t-wrap overflow-auto'>
                          <Table
                            className='mb-0 w-100 txn__table'
                            striped
                            hover
                            responsive
                          >
                            <thead>
                              <tr>
                                <th>SIP Id</th>
                                <th>Order Id</th>
                                <th>Investment Amount</th>
                                <th>Payment Date</th>
                                <th>Status</th>

                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {completedList?.length > 0 ? (
                                <>
                                  {completedList?.map((list, index) => (
                                    <tr key={index}>
                                      <td>{list?.sipId}</td>
                                      <td>{list?.orderId}</td>
                                      <td>
                                        ₹
                                        {list.installmentAmount
                                          ? list?.installmentAmount
                                          : '-'}
                                      </td>
                                      <td className=''>
                                        {moment(list?.createdAt).format(
                                          'DD-MMM-yyyy'
                                        )}
                                      </td>
                                      <td>
                                        {list?.status ? list?.status : 'PENDING'}
                                      </td>
                                      {list?.isPayButton &&
                                        list?.sipStatus == 'ACTIVE' && isSipActive ? (
                                        <td>
                                          <Button
                                            onClick={() =>
                                              displayPayMethod(
                                                list?.sipId,
                                                list?.orderId
                                              )
                                            }
                                            variant='primary'
                                            bsPrefix='btn-table'
                                            style={{ width: '80px' }}
                                          >
                                            Pay Now
                                          </Button>
                                        </td>
                                      ) : (
                                        <td>-</td>
                                      )}
                                    </tr>
                                  ))}
                                </>
                              ) : (
                                <tr>
                                  <td colSpan={6}>
                                    <div className='m-2 d-flex justify-content-center'>
                                      No data to display
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </Col>
                    </Row>
                  </Tab>
                  <Tab eventKey='upcoming' title='Upcoming' className="mb-3">
                    {/* <h2>Upcoming SIP</h2> */}

                    <Row>
                      <Col md={12}>
                        <div className='t-wrap overflow-auto'>
                          <Table
                            className='mb-0 w-100 txn__table'
                            striped
                            hover
                            responsive
                          >
                            <thead>
                              <tr>
                                <th>Id</th>
                                <th>Schedule Date</th>
                                <th>Payment Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {upcomingList?.length > 0 ? (
                                <>
                                  {upcomingList?.map((list, index) => (
                                    <tr key={index}>
                                      <td>{list?.sipId}</td>

                                      <td className=''>
                                        {moment(list?.scheduleDate).format(
                                          'DD-MMM-yyyy'
                                        )}
                                      </td>
                                      <td className=''>PENDING</td>
                                    </tr>
                                  ))}
                                </>
                              ) : (
                                <tr>
                                  <td colSpan={4}>
                                    <div className='m-2 d-flex justify-content-center'>
                                      No data to display
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </Col>
                    </Row>
                  </Tab>
                </Tabs>
              </Col>
            </Row>
            <SipPayMethod
              show={isDisplayPayMethod}
              onClick={selectSipPayMethod}
              paymentMethod={paymentMethod}
              setPaymentMethod={setPaymentMethod}
              paymentProvider={paymentProvider}
              setPaymentProvider={setPaymentProvider}
              setIsDisplayPayMethod={setIsDisplayPayMethod}
            />
            <OtpPopup
              show={isOTPModalShow}
              isLoading={loading}
              handleClose={() => {
                resetOtpData();
                setIsOTPModalShow(false);
              }}
              modalTitle={`Metal ${quoteData?.type === 'SELL' ? 'Purchase' : 'Sell'
                } Confirmation`}
              modalSubmitBtnText='Verify'
              onSubmit={() => onSubmitOTP()}
              otpLabel={format(OTP_SENT_TO_REG_MESSAGE, {
                suffixDigits: user?.mobile?.value?.slice(-4),
              })}
              enableResendTimer={true}
              resendHandler={() => {
                resetOtpData();
                resendOTP();
              }}
              otpChangeHandler={(value) => {
                setOtpData({
                  value: value,
                  ackMessage: '',
                  ackMessageType: 'success',
                });
              }}
              resendButtonText='Resend OTP'
              ackMessage={otpData.ackMessage}
              ackMessageType={otpData.ackMessageType}
              numInputs={6}
              otpValue={otpData.value}
              resendInterval={30}
            />
          </div>
        )}
      </Container>

      <ConfirmActionModal
        show={showDeactivateModal}
        onCancel={() => setShowDeactivateModal(false)}
        onConfirm={confirmDeactivateSip}
        title="Deactivate SIP?"
        description={
          <>
            Are you sure you want to deactivate this SIP?
            Once deactivated, it cannot be reactivated.
          </>
        }
        confirmText="Deactivate SIP"
        intent="danger"
      />
    </Layout>
  );
};

export default PaymentSchedule;
